import { Component, Input, OnInit } from "@angular/core";
import { StaffService } from "../scanhistory.component";

@Component({
	selector: "caass-staff-scan-history-reminders",
	templateUrl: "./staff-scan-history-reminders.component.html",
	styleUrls: ["./staff-scan-history-reminders.component.css"],
})
export class StaffScanHistoryRemindersComponent implements OnInit {
	constructor(private ScanHistoryService: StaffService) {}

	ngOnInit(): void {
		this.loadStationReminderAlert();
	}

	ngOnChanges() {
		this.loadStationReminderAlert();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//Input
	@Input() SelectedEntry: any;

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedStationReminderAlert: any;
	lstStationReminderAlert: any = [];

	//Filter lists
	lstAlertTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'Message', header: 'Message' },
		// { field: 'SoundFile', header: 'Sound' },
		// { field: 'AlertTypeDesc', header: 'Occurs' },
		// { field: 'RangeDesc', header: 'Next Occurrence' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadStationReminderAlert() {
		if (this.SelectedEntry == undefined) {
			this.lstStationReminderAlert = [];
			this.lstAlertTypeDesc = [];
		}

		var result = this.ScanHistoryService.StationReminderInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				this.lstStationReminderAlert = response;

				//Load Data Filter Lists
				this.lstAlertTypeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.AlertTypeDesc))).sort();
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadStationReminderAlert();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedStationReminderAlert = val.data;
	}
	onRowUnselect(val) {
		this.SelectedStationReminderAlert = null;
	}
	////////////////////////////////////////////
}
